
























































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import Pagination from '@morpheus/utils/admin-vue/mixins/pagination'
import ProductsList from '../components/ProductsList.vue'
import { deleteProductById, fetchProductsList } from '../services/products-client'
import { ProductShowData, ProductsListData } from '../types'

export default mixins(Pagination).extend({
  name: 'Products',
  components: {
    ProductsList
  },
  data () {
    return {
      isLoading: true,
      headers: [
        { text: 'SKU', value: 'sku', sortable: false },
        { text: 'Created At', value: 'created_at', sortable: false },
        { text: 'Updated At', value: 'updated_at', sortable: false },
        { text: 'Actions', value: '_id', align: 'center', sortable: false }
      ],
      itemsList: []
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchProductsList(`?limit=${this.rowsPerPage}&offset=${this.paginationOffset}`)
        .then(({ items, total }: ProductsListData) => {
          this.itemsList.splice(0, this.itemsTotal)
          items.forEach((item: ProductShowData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
          this.itemsTotal = total
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.checkPagination()
          this.isLoading = false
          this.$store.commit('global/setLoading', false)
        })
    },
    onDeleteProduct (id: string, disableListings: boolean) {
      this.isLoading = true
      const queryParams = disableListings ? '?cascade=delete' : ''
      deleteProductById(id, queryParams)
        .then(() => {
          this.fetchItems()
          this.$store.commit('global/addNotification', {
            text: 'You successfully deleted product!',
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
})
